var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{staticClass:"container backgroundColor bordered mt-5 rounded"},[_c('router-view')],1)]),_c('SuccessMessage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }